<template>
    <v-layout fill-height row justify-center :class="flexClass">
        <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>
        <v-flex sm12 md10 lg8 p-0>
            <v-card class="fill-height">
                <!-- <v-breadcrumbs :items="breadCrumbs" class="dense">
                    <template v-slot:divider>
                        <v-icon>forward</v-icon>
                    </template>
                </v-breadcrumbs> -->
                <!--
                <v-card-title>
                    <h2>{{ $t("myAccount") }}</h2>
                </v-card-title>
                -->

                <v-toolbar card prominent dense>
                    <v-tooltip
                        bottom
                        :disabled="true"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                v-on="on"
                                @click="getUserInfo"
                            >
                                <v-icon>mdi-reload</v-icon> {{ $t("reload") }}
                            </v-btn>
                        </template>
                        <span>{{ $t("reload") }}</span>
                    </v-tooltip>
                    <v-tooltip
                        bottom
                        :disabled="true"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                v-on="on"
                                @click="updateUserInfo"
                            >
                                <v-icon>mdi-content-save-outline</v-icon> {{ $t("save") }}
                            </v-btn>
                        </template>
                        <span>{{ $t("save") }}</span>
                    </v-tooltip>
                </v-toolbar>

                <v-card-text class="v-scrollable">
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-layout wrap>
                                    <div class="ma-2" style="width: 55px;">
                                        <img avatar class="border-rounded" :src="imageUrl" height="50" width="50" v-if="imageUrl"/>
                                    </div>
                                    <v-flex>
                                        <v-text-field
                                            :label="`${$t('selectImage')}`"
                                            @click="pickFileClick"
                                            v-model="imageName"
                                            prepend-icon="attach_file"
                                        ></v-text-field>
                                        <input
                                            type="file"
                                            id="image"
                                            ref="image"
                                            accept="image/*"
                                            style="display: none"
                                            @change="onFilePicked"
                                        >
                                    </v-flex>

                                </v-layout>
                            </v-flex>

                            <v-flex xs12 sm6 md4>
                                <v-text-field
                                    v-model="lastName"
                                    :label="`${$t('lastName')} *`"
                                    required>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                                <v-text-field
                                    v-model="firstName"
                                    :label="`${$t('firstName')} *`"
                                    required>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                                <v-text-field
                                    v-model="middleName"
                                    :label="$t('middleName')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="companyName"
                                    :disabled="true"
                                    :label="`${$t('company')}`"
                                    required
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="eMail"
                                    :label="`${$t('eMail')} *`"
                                    :rules="[rules.required, rules.eMail]"
                                    required
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 v-if="curEMail !== eMail">
                                <v-alert type="warning" value="curEMail !== eMail" icon="mdi-alert" transition="scale-transition">
                                    {{ $t("reloginAfterEMailChange") }}
                                </v-alert>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                    v-model="password1"
                                    :label="`${$t('password')}`"
                                    :rules="[passwordsMatch]"
                                    type="password"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                    v-model="password2"
                                    :label="`${$t('passwordConfirm')}`"
                                    :rules="[passwordsMatch]"
                                    type="password"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <small>{{ $t("requiredFieldPointer") }}</small>
                </v-card-text>
            </v-card>

            <message-box ref="MessageBox"/>

            <v-alert
                :value="alert !== ''"
                :type="alertType"
                transition="scale-transition"
                class="bottom-alert"
            >
                {{ alert }}
            </v-alert>
        </v-flex>
    </v-layout>
</template>

<script>
    import MessageBox from "@/components/dialogs/MessageBox"

    export default {
        name: "EditAccount",

        components: {
            MessageBox
        },

        data () {
            return {
                alert: "",
                alertType: "success",

                breadCrumbs: [
                    { text: "Моя учетная запись", disbaled: false }
                ],

                progressBarVisible: false,
                haveChanges: false,
                firstName: "",
                middleName: "",
                lastName: "",

                userId: null,
                companyId: null,
                companyName: "",
                curEMail: "",
                eMail: "",
                password1: "",
                password2: "",

                imageFile: "",
                imageName: "",
                imageUrl: "",

                //passwordsMatch: true,

                rules: {
                    required: value => !!value || this.$t("requiredField"),
                    eMail:    value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || this.$t("invalidEMail")
                    }
                }
            }
        },

        watch: {
            alert: function (val) {
                let component = this;
                if (val !== "") {
                    setTimeout(() => {
                        component.alert = "";
                    }, 3000);
                }
            },

            password1: function (val) { this.passwordsMatch = val == this.password2; },
            password2: function (val) { this.passwordsMatch = this.password1 == val; },
        },

        computed: {
            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            },

            passwordsMatch () {
                return (this.password1 === this.password2) || this.$t("passwordsMismatch");
            }
        },

        mounted () {
            this.applyLocale();
            this.getUserInfo();

            this.$root.$on("localeChanged", () => { this.applyLocale(); });
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.breadCrumbs = [
                    { text: this.$t("myAccount"), disabled: false }
                ];
            },

            /**
             *  Получение информации об авторизованном пользователе
             */
            getUserInfo () {
                let accountMan = this;

                this.axios.get(`${this.$config.apiURL}users/logged_in/`, { withCredentials: true })
                .then(response => {
                    if (response.data.user.rows == undefined) { return; }

                    let userInfo = response.data.status == "success"
                        ? response.data.user.rows[0]
                        : {};

                    this.companyId = userInfo.Company.id,
                    this.userId    = userInfo.id;
                    this.firstName = userInfo.FirstName !== null
                                    ? userInfo.FirstName.trim() + " "
                                    : "";
                    this.middleName = userInfo.MiddleName !== null
                                    ? userInfo.MiddleName.trim() + " "
                                    : "";
                    this.lastName = userInfo.LastName !== null
                                    ? userInfo.LastName.trim() + " "
                                    : "";
                    this.companyName = userInfo.Company.Name.trim();
                    this.eMail       = userInfo.EMail.trim();
                    this.curEMail    = userInfo.EMail.trim();
                    //this.user.avatar   = ${this.$config.apiURL} + "users/" + userInfo.id + "/avatar/";
                    //this.user.role     = userInfo.RoleId;
                    //this.user.loggedIn = true;
                    //this.loggedIn      = true;

                    this.imageName = "";
                    this.imageFile = "";
                    this.imageUrl  = `${accountMan.$config.apiURL}users/${userInfo.id}/avatar/?rand=${Math.floor(Math.random() * 1000000000)}`;

                    //this.$store.commit("setUser", this.user);
                }).catch(error => {
                    this.$debug.error(error);

                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadUserInfo") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadUserInfo") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadUserInfo"));
                    }
                });
            },

            /**
             *  Обработчик выбора файла
             */
            onFilePicked (e) {
                const files = e.target.files;
                if(files[0] !== undefined) {
                    this.imageName = files[0].name;
                    if(this.imageName.lastIndexOf(".") <= 0) {
                        return;
                    }
                    const fr = new FileReader ()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener("load", () => {
                        this.imageUrl  = fr.result;
                        this.imageFile = files[0]; // this is an image file that can be sent to server...
                    });
                } else {
                    this.imageName = "";
                    this.imageFile = "";
                    this.imageUrl  = "";
                }
            },

            /**
             *  Обработчик нажатия кнопки выбора файла
             */
            pickFileClick () {
                this.$refs.image.click();
            },

            /**
             * Отображает сообщение
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },

            /**
             *  Обновление информации о пользователе
             */
            updateUserInfo () {
                let formData = new FormData();

                formData.append("file",       this.imageFile);
                //formData.append("imageFile", this.imageFile);
                formData.append("firstName",  this.firstName);
                formData.append("middleName", this.middleName);
                formData.append("lastName",   this.lastName);
                formData.append("eMail",      this.eMail);
                formData.append("password",   this.password1);
                formData.append("companyId",  this.companyId);
                formData.append("userId",     this.userId)

                this.axios({
                    method: "patch",
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    url:  `${this.$config.apiURL}users/${this.userId}/`,
                    data: formData,
                    withCredentials: true
                }).then(() => {
                    //this.showMessageBox(this.$t("information"), this.$t("userUpdated"));
                    this.alertType = "success";
                    this.alert     = this.$t("dataUpdated");

                    if (this.curEMail !== this.eMail) {
                        this.$emit("doLogout", true);
                    } else {
                        this.$emit("usersUpdated", true);
                    }
                }).catch(error => {
                    this.$debug.error(error);

                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantUpdateUser") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantUpdateUser") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantUpdateUser"));
                    }
                });

                this.dialog = false;
            }
        }
    }
</script>

<style lang="sass" scoped>
    .layout.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100vh - 144px)
</style>
